import saveAs from 'file-saver';
import { format } from "date-fns";
const getBase64StringFromBlobUrl = (blob, mimeType, fileName) => {
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
        let base64String = reader.result;
        if (window.Android?.convertBase64StringToFileAndStoreIt) {
            window.Android.convertBase64StringToFileAndStoreIt(base64String, mimeType, fileName);
        }
    };
};
export const saveFile = (response, fileName, type) => {
    // Android and iOS needs special handling
    const fileType = type || 'application/pdf';
    const blob = new Blob([response.data], { type: fileType });
    if (window.Android) {
        getBase64StringFromBlobUrl(blob, fileType, fileName);
    }
    else {
        if (window.webkit?.messageHandlers?.convertBase64StringToFileAndStoreIt) {
            window.webkit.messageHandlers.convertBase64StringToFileAndStoreIt.postMessage(fileName);
        }
        saveAs(blob, fileName);
    }
};
export const getPdfFilename = (prefix, firstName = 'dental', lastName = 'consumer', now) => {
    return (prefix + firstName + `-` + lastName).replace(/[^-a-z0-9]/gi, '_') + `-` + format(now, 'MM-dd-yyyy') + `.pdf`;
};
